import $ from 'jquery';

/**
 * Defines the className of the dot button
 * @type {string}
 */
export const DOT_CLASS = 'image-carousel__dot-button';

/**
 * Allows us to customize the "dot buttons"
 * @param {jQuery} $slides - slick slides (from slick)
 * @param {number} i - iterator, used to select current slide from $slides
 * @see DEFAULT_OPTIONS
 * @return {jQuery} "dot button"
 */

 const updateCounterMarkup = (e, slick, $el, slickContainer, counterContainer) => {
  const $parentElement = slickContainer.length ? $(slickContainer) : $el;
  const counterContainerIsProvided = counterContainer.length;

  if(counterContainerIsProvided) {
    $parentElement.find(counterContainer).html(slick.currentSlide + 1 +' / '+slick.slideCount);
  } else {
    $parentElement.find('.image-carousel__counter').html(slick.currentSlide + 1 +' / '+slick.slideCount);
  }
 };

 const counterMarkup = (e, slick, $el, slickContainer, counterContainer) => {
  const slickContainerIsProvided = slickContainer.length;
  const counterContainerIsProvided = counterContainer.length;
  const $parentElement = slickContainerIsProvided ? $(slickContainer) : $el;
  const $counterContainer = $(counterContainer);

  if(slickContainerIsProvided && counterContainerIsProvided) {
    $counterContainer.append(`${parseInt(slick.currentSlide + 1, 10)} / ${slick.slideCount} `);
  } else {
    $parentElement.append('<div class="image-carousel__counter">'+ parseInt(slick.currentSlide + 1, 10) +' / '+ slick.slideCount +'</div>');
  }
  
 };

export default function createCounter($el, slickContainer, counterContainer) {
  $el.on('init', function(e, slick) {
    counterMarkup(e, slick, $el, slickContainer, counterContainer);
  });
  $el.on('afterChange', function(e, slick) {
    updateCounterMarkup(e, slick, $el, slickContainer, counterContainer);
  });
}



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/slick/counter.js